import { RouteConfig } from 'vue-router';

const AccountManage = () => import(/* webpackChunkName: "Account" */  './views/account-manage/account-manage.vue');
const AccountSetting = () => import(/* webpackChunkName: "Account" */  './views/account-setting/account-setting.vue');
const HelpCenter = () => import(/* webpackChunkName: "Account" */  './views/help-center/help-center.vue');



const routers: RouteConfig[] = [
    {
        path: 'account-manage',
        component: AccountManage
    },
    {
        path: 'account-setting',
        component: AccountSetting
    },
    {
        path: 'help-center',
        component: HelpCenter
    },
    {
        path: '',
        redirect: 'account-manage'
    },
];

export default routers;

